module.exports = __webpack_public_path__ + "img/icon-import.99f8f35a.svg";